/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import DatePicker, { DateObject } from "react-multi-date-picker";
import "react-datepicker/dist/react-datepicker.css";
import "react-multi-date-picker/styles/layouts/mobile.css"
import "react-multi-date-picker/styles/colors/teal.css"
import moment from 'moment';
import { FormHelperText } from '@mui/material';
import { months, weekDays } from '../Utils/Function';
import { useTailwindBrand } from './shared';

interface Props {
    defaultValue?: any
    customMultiDatePicker?: string
    setStartDate: React.Dispatch<any>
    setEndDate: React.Dispatch<any>
    customMultiDate?: string
    customMobileLabels?: {
        OK: string;
        CANCEL: string;
    }
    label?: string
    require?: string
    setDatesValues?: any
    startAt?: any
    numberOfMonths?: number
    error?: boolean
    errorMsg?: string
    setIsOver?: any
}


const MultiDatePicker = (props: Props) => {
    const today = new Date();
    const currentMonth = moment(today).format("MM");
    const startMonth = moment(props?.startAt).format("MM");
    const { classes, brand } = useTailwindBrand();
    const startOfMonth = moment().startOf('month');
    const fourAM = startOfMonth.clone().hour(4);
    let hour
    let minute
    const [values, setValues] = useState([
        props.defaultValue ?
            ((currentMonth === startMonth) && (new DateObject(props?.startAt) > new DateObject(props.defaultValue[0])) ?
                new DateObject(props?.startAt) : new DateObject(props.defaultValue[0]))
            : (currentMonth === startMonth ? new DateObject(props?.startAt) : new DateObject().toFirstOfMonth()),
        props.defaultValue ? new DateObject(props.defaultValue[1]) : new DateObject().toLastOfMonth()
    ]);

    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const endLastDay = moment(lastDayOfMonth).format("YYYY-MM-DD 20:00:00");
    const min = today.getMinutes();
    const valeur = 60 - min;
    const newMin = valeur + min;

    // Calculer `result` uniquement lorsque `values` change
    const result = useMemo(() => {
        return values.map((date) => moment(date?.toDate?.()).format("YYYY-MM-DD"));
    }, [values]);

    useEffect(() => {

        if (moment(moment(result[1]).format("YYYY-MM-DD")).isSame(startOfMonth, 'day') && moment(moment(result[1]).format("YYYY-MM-DD")).isBefore(fourAM)) {
            hour = fourAM.toDate().getHours()
            minute = fourAM.toDate().getMinutes()
        } else {
            hour = today.getHours() + 2
            minute = newMin
        }

        const endDateTimeOfLastDay = moment(moment(result[1]).format("YYYY-MM-DD"))
            .set("hour", 23)
            .set("minutes", 50)
            .format("YYYY-MM-DD HH:mm:ss");

        const startDateTime = moment(props?.startAt).format("YYYY-MM-DD") === moment(result[0]).format("YYYY-MM-DD") ?
            moment(props?.startAt)
                .add(3, 'hours')
                .add(3, 'hours')
                .toDate()
            : moment(result[0])
                .set("hour", hour)
                .set("minutes", minute)
                .toDate();
        const endDateTime = endDateTimeOfLastDay > endLastDay
            ? moment(moment(result[1]).format("YYYY-MM-DD"))
                .set("hour", 19)
                .set("minutes", 59)
                .toDate()
            : moment(moment(result[1]).format("YYYY-MM-DD"))
                .set("hour", hour)
                .set("minutes", minute)
                .toDate();
        if (props.setIsOver) {
            props.setIsOver(endDateTime < today ? true : false);
        }
        props.setStartDate(startDateTime);
        props.setEndDate(endDateTime);
        props.setDatesValues(values)
    }, [result]);

    return (
        <div className={`w-full ${props.customMultiDatePicker ?? ''} bg-white rounded-md border ${props.error ? `${classes.errorBorder} border-l-4` : 'border-gray-400'}`}>
            <label className={`text-xs font-semibold ${classes.text} ${classes.fontFamily} block px-3 pt-1 /mb-1`}>
                {props.label}
                {props.require && <span className={classes.error}> *</span>}
            </label>
            <div
                className={` px-3 /py-3 ${classes.fontFamily} flex items-center /min-h-[48px]`}
            >
                <DatePicker
                    portal={props.customMultiDate ? false : true}
                    value={values}
                    inputClass={`w-full bg-transparent cursor-pointer ${classes.fontFamily} text-sm focus:outline-none`}
                    className={brand === "verified-trainer" ? `teal` : ""}
                    onChange={(e: any) => setValues(e)}
                    numberOfMonths={props.numberOfMonths ?? 1}
                    weekStartDayIndex={1}
                    placeholder="Filtrer par période"
                    containerStyle={{ width: "100%", border: "none" }}
                    months={months}
                    weekDays={weekDays}
                    format={"DD/MM/YYYY"}
                    minDate={currentMonth === startMonth ? new DateObject(props.startAt) : new DateObject().toFirstOfMonth()}
                    maxDate={new DateObject().add(1, "M").toLastOfMonth()}
                    range
                />
            </div>
            {props.error && props.errorMsg && (
                <FormHelperText className={`${classes.fontFamily} ${classes.error} italic font-semibold`}>
                    {props.errorMsg}
                </FormHelperText>
            )}
        </div>
    );
};

export default MultiDatePicker;